import { OutboundCallControllerService } from '../services/call-management';
import type { MakeCallRequest } from '../services/call-management';
import { getCurrentOrg } from './getCurrentOrg';

export type CallPayload = MakeCallRequest;

export const makeAgentCall = (payload: MakeCallRequest) => {
  return OutboundCallControllerService.makeCall(getCurrentOrg(), {
    ...payload,
  });
};
